import React from 'react';
import './MissionTimeline.scss';

export default function MissionTimeline({ content }) {
  return (
    <section className="site-section mission" id="mission" aria-labelledby="mission-heading">
      <h2 className="section-heading" id="mission-heading" data-reveal data-dismiss>
        <span className="reveal__content">{content.heading}</span>
      </h2>
      <p className="mission__subtitle type-h1" data-reveal data-dismiss>
        <span className="reveal__content">{content.subtitle}</span>
      </p>
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles -- Safari needs the explicit role when list markers are hidden. */}
      <ol className="mission__timeline" role="list">
        {content.events.map(event => (
          <li className="mission__event" key={event.year}>
            <time className="mission__year" dateTime={String(event.year)} data-dismiss>{event.year}</time>
            <article className="mission__card">
              <div className="mission__media" data-pop data-dismiss>
                <div className={`pop__content mission__bubble${event.image ? '' : ' mission__bubble--abstract'}`}>
                  {event.image && <img src={event.image.src} alt={event.image.alt} width={event.image.width} height={event.image.height} loading="lazy" decoding="async" />}
                </div>
              </div>
              <div className="mission__copy" data-dismiss>
                <h3>{event.title}</h3>
                {event.description && <p>{event.description}</p>}
              </div>
            </article>
          </li>
        ))}
      </ol>
    </section>
  );
}
